
// 请求接口列表
export default {
  // 文件版本列表
  getFileVersionList: '/doclogic/v1/file/version/list',
  // 文件版本恢复
  fileVersionReset: '/doclogic/v1/file/version/reset',
  // 查询文件所属库信息
  fileReleaseSet: '/doclogic/v1/doclibrary/teamlib/fileReleaseSet',
  // 通过、驳回、撤回三种操作
  fileReleaseAudit: '/doclogic/v1/doclibrary/teamlib/fileRelease/audit',
  // 文件发布
  filePublish: '/doclogic/v1/doclibrary/file/publish',
  // 获取文件预览URL（带水印）， source = APP 、WEB 、DESKTOP (移动端或者PC端,默认WEB)
  getWaterMarkUrl: '/doclogic/v1/wopi/getWaterMarkUrl'
}
